import { FlaskConical, Star } from "lucide-react";
import type { ReactElement } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

type MemberMarkersProps = {
    isTestMember: boolean;
    isVipMember: boolean;
};

/**
 * Shown after a member's name, so that agents can tell VIP members and test
 * accounts apart wherever members are listed.
 */
export function MemberMarkers({ isTestMember, isVipMember }: MemberMarkersProps) {
    return (
        <>
            {isVipMember && (
                <MarkerIcon label="VIP member">
                    <Star className="size-4 fill-amber-400 text-amber-500" />
                </MarkerIcon>
            )}
            {isTestMember && (
                <MarkerIcon label="Test member">
                    <FlaskConical className="size-4 text-violet-700" />
                </MarkerIcon>
            )}
        </>
    );
}

function MarkerIcon({ label, children }: { label: string; children: ReactElement }) {
    return (
        // The tooltip renders in a portal, because the hidden label of the CSS
        // tooltip counted as overflow and caused scrollbars in scrolling lists.
        <Tooltip>
            <TooltipTrigger
                render={
                    <span
                        role="img"
                        aria-label={label}
                        className="inline-flex shrink-0 align-middle"
                    />
                }
            >
                {children}
            </TooltipTrigger>
            <TooltipContent side="bottom">{label}</TooltipContent>
        </Tooltip>
    );
}
